
<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>PARENT DEPARTMENT<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save" id="btn_Department_save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="departments" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="departmentColumns" [selectionField]="'ParentDepartment_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addDepartment($event)" (editEntity)="editDepartment($event)"
            (refreshEntities)="refreshDepartments($event)" (deleteEntity)="deleteDepartment($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearDepartment()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Parent Department Name'" [formData]="entity" [maxlength]="100" [mandatory]="true" id="txt_Department_name"
                            [fieldName]="'ParentDepartmentName'" [(ngModel)]="entity.ParentDepartmentName"  ngDefaultControl>
                        </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"  [fieldName]="'ParentDepartmentCode'" 
                    [(ngModel)]="entity.ParentDepartmentCode" ngDefaultControl id="txt_Department_Prefix"></textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Head'" [formData]="entity" [data]="employees" [class] = "'form-control'"
                    [mandatory]="true" [filterable]="true" (filterChanged)="getAllEmployees($event)" id="drp_Department_Head"
                    [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                    [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee" ngDefaultControl>
                </dropdown>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email Id'" [formData]="entity" [maxlength]="100" [mandatory]="false"
                    [fieldName]="'EmailId'"  [(ngModel)]="entity.EmailId" ngDefaultControl id="drp_Department_Email"></textbox>
                </div>
            </div>
         
            <div class="row">
               
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [formData]="entity"  [mandatory]="false" id="txt_Department_Phone"
                    [fieldName]="'Phone'"   [(ngModel)]="entity.Phone" (keypress)="numberOnly($event)" [maxlength]="10"
                        ngDefaultControl></textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive" chk="chk_Department_Active"></checkbox>
                </div>
            </div>
           
           <!---- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                        title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" id="btn_Department_save" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div>-->
        </div>
        
    </div>
</div>

<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Parent Department Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="ParentDepartmentName" class="label label-1">Parent Department Name : </label> {{details.ParentDepartmentName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="ParentDepartmentCode" class="label label-1">Code : </label> {{details.ParentDepartmentCode}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="EmployeeName" class="label label-1">Department Head : </label> {{details.EmployeeName}}
          </div>
          </div>
          <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="Email" class="label label-1">Email Id : </label>  {{details.EmailId}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Phone" class="label label-1">Phone Number : </label>  {{details.Phone}}
          </div>
          </div>
        </div>
    </kendo-dialog>

<kendo-excelexport [data]="departments.data" [collapsible]="true" fileName="Parent Department.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ParentDepartmentName" title="Parent Department" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="ParentDepartmentCode" title="Code" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="EmployeeName" title="Head" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ParentDepartmentMail" title="Email" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ParentDepartmentPhone" title="Phone" [width]="200">
    </kendo-excelexport-column> 
    <!-- <kendo-excelexport-column field="CompanyName" title="Company" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="DivisionName" title="Division" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="LocationName" title="Location" [width]="200">
    </kendo-excelexport-column>   -->
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>